// extracted by mini-css-extract-plugin
export default {"root":"ItemRow__root--3vBfh"};